import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import InputText from './Input/InputText';
import SearchIcon from './Icons/SearchIcon';
import CloseIcon from './Icons/CloseIcon';
import { theme } from '../theme';

const AgendaSearch = ({ searchTerm, onSearchChange, onClearSearch }) => {
  const { t } = useTranslation('agenda');

  return (
    <SearchContainer>
      <SearchInputWrapper>
        <SearchIconWrapper>
          <SearchIcon fill={theme.colors.defaultWeak} width={16} height={16} />
        </SearchIconWrapper>
        <StyledInputText
          type="text"
          placeholder={t('search.placeholder', 'Buscar por nombre del evento u organizador...')}
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
        {searchTerm && (
          <ClearButton onClick={onClearSearch}>
            <CloseIcon fill={theme.colors.defaultStrong} width={16} height={16} />
          </ClearButton>
        )}
      </SearchInputWrapper>
    </SearchContainer>
  );
};

export default AgendaSearch;

const SearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.xs};
  width: 100%;
`;

const SearchInputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
`;

const SearchIconWrapper = styled.div`
  position: absolute;
  left: 12px;
  display: flex;
  align-items: center;
  pointer-events: none;
  z-index: 1;
`;

const StyledInputText = styled(InputText)`
  padding-left: 40px;
  padding-right: ${({ theme }) => theme.sizing.lg};
  width: 100%;
`;

const ClearButton = styled.button`
  position: absolute;
  right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.fill.defaultWeak};
  }
`;